import React from "react";
import "./Home.css";
import Layout from "../components/shared/Layout";
import Hero from "../sections/home/Hero";
import Video from "../sections/home/Video";
import Services from "../sections/home/Services";
import Strengths from "../sections/home/Strengths";
import Contact from "../sections/home/Contact";
// import Testimonials from '../sections/home/Testimonials';
import WhyICS from "../sections/home/WhyICS";
import Futurecredentialing from "../sections/home/Futurecredentialing";

const Home = () => {
    return (
        <Layout>
            <link
                rel="canonical"
                href={`https://icredentialing.com}`}
            />
            <div className="home-page">
                <Hero />
                <Video />
                <Services />
                <WhyICS />
                <Futurecredentialing />
                <Strengths />
                <Contact />
            </div>
        </Layout>
    );
};

export default Home;
